import React from "react";
import {useTranslation} from "react-i18next";
import {Form, Input, message, Select} from "antd";
import {StyledSelect} from "../../../EntrantApplication/index.styles";
import dayjs from "dayjs";


const { Option } = Select;
const { TextArea } = Input;

export const AdmissionRejectForm = ({
                                      formRef, formData, infoOfOrder, onValuesChange, executorData, edit
                                    }: any) => {
  const { t } = useTranslation(['executorAdmissionSteps', 'admissionNotes']);
  const reasonsList = t('selectList', { returnObjects: true }) as any;

  return (
    <Form form={formRef} name="reject_note_form" layout="vertical" onValuesChange={onValuesChange} onFinish={() => message.success('success')} onFinishFailed={() => message.error(':(')}>
      {
        !edit ? (
            <>
              {/*@ts-ignore*/}
              <p>{reasonsList[formData.reason - 1]}</p>
              <p>{formData.comment ? formData.comment : ''}</p>
            </>
          ) :
          <>
            <Form.Item name='reason' label={t("admissionNotes:rejectNote.reason.label")}
                       rules={[{ required: true, message: t("admissionNotes:rejectNote.reason.placeholder") }]}>
              <StyledSelect placeholder={t('admissionNotes:fromList')} showSearch={true}
                            optionFilterProp="children"
                            filterOption={(input, option:any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {reasonsList.map((reason:any, idx:any) => (
                  <Option key={idx + 'reason'} value={idx + 1}>{reason}</Option>
                ))}
              </StyledSelect>
            </Form.Item>

            {formData.reason === 1 || formData.reason === 2 || formData.reason === 7 ? (
              <>
                {formData.reason === 1 || formData.reason === 2 ?
                  <p className='documentsName'>{t('admissionNotes:rejectNote.comment.title')}:</p> : null}
                <Form.Item name='comment' label={t('admissionNotes:rejectNote.comment.label')}
                           rules={[{ required: formData.reason === 7, message: t('admissionNotes:rejectNote.comment.placeholder1') }]}>
                  <TextArea rows={4} placeholder={t('admissionNotes:rejectNote.comment.placeholder2')}/>
                </Form.Item>
              </>
            ) : null}
          </>
      }

      <p style={{ marginTop: '16px', marginBottom: '16px' }}>{t('admissionNotes:rejectNote.receiptTitleSubtitle')}</p>

      <p className='executor-caption'>{executorData && executorData.executor ? executorData.executor.fio : 'Исполнитель не найден'}</p>
      <p className='executor-subtitle'>{t('admissionNotes:executorLabel')}</p>


      {/*{!edit ? <p>{formData.phone}</p> :*/}
      {/*  <Form.Item name='phone' label={t('admissionNotes:executorContactPhone')}*/}
      {/*             rules={[{ required: true, message: t("admissionNotes:alertPhone") }]}>*/}
      {/*    <Input placeholder={t("admissionNotes:placeholderPhone")}/>*/}
      {/*  </Form.Item>*/}
      {/*}*/}


      <p
        className='executor-caption'>{t("admissionNotes:person")}: {infoOfOrder.data && infoOfOrder.data.educationOrder ? (infoOfOrder.data.educationOrder.parent_name ? (`${infoOfOrder.data.educationOrder.parent_surname} ${infoOfOrder.data.educationOrder.parent_name} ${infoOfOrder.data.educationOrder.parent_patronymic_entrant}`)
        : infoOfOrder.data.educationOrder.name_entrant ? (`${infoOfOrder.data.educationOrder.name_entrant} ${infoOfOrder.data.educationOrder.surname_entrant} ${infoOfOrder.data.educationOrder.patronymic_entrant}`) : 'smth with parent or entrant') : 'smth with entrant'}</p>
      <p className='executor-subtitle'>{t("admissionNotes:uslugopoluchatelLabel")}</p>


      <p>{t("admissionNotes:dateOfReceipt")} {dayjs().format('DD.MM.YYYY')}</p>

      {/*{!edit ? `Дата получения расписки: ${moment(formData.date).format('DD.MM.YYYY')}` :*/}
      {/*  <Form.Item name="date" label="Дата получения расписки"*/}
      {/*             rules={[{ required: true, message: 'Необходимо выбрать дату!' }]}>*/}
      {/*    <DatePicker style={{ width: '13%' }} locale={locale} placeholder='«‎___» ______________ 20__ года‎'*/}
      {/*                value={dateOfNote} format='‎DD/MM/YYYY'*/}
      {/*                onChange={(date) => setDateOfNote(date)}/>*/}
      {/*  </Form.Item>*/}
      {/*}*/}
    </Form>
  )
}